<template>
    <div class="lp-filter" role="listbox" :aria-label="Filters">
        <button type="button"
                class="lp-filter__item"
                v-for="(option, index) in options"
                :key="`filter-${index}`"
                :class="{ active: option.selected }"
                :style="[option.selected ? 
                            {
                                'background-color': option.backgroundColor,
                                'border-color': option.backgroundColor
                            } : {
                                'background-color': 'transparent', 
                                'border-color': option.backgroundColor
                            },
                            {
                                'color': option.textColor
                            }
                        ]"
                v-on:click="optionClickedHandler(option)"
                role="option"
                :aria-selected="option.selected">

        <img class="lp-filter__icon" v-if="option.icon" :src="option.icon" />
            {{ option.name }}
        </button>
    </div>
</template>

<script>
    import { computed, reactive } from 'vue';

    export default {
        name: 'TagFilter',
        methods: {
            optionClickedHandler: function (option) {
                this.$emit('option-clicked', option);
            }
        },
        props: {
            options: {
                type: Array,
                required: true,
                validator: (value) => {
                    let valid = true;
                    for (let i = 0; i < value.length; i += 1) {
                        if (
                            !Object.prototype.hasOwnProperty.call(value[i], 'name') &&
                            !Object.prototype.hasOwnProperty.call(value[i], 'value')
                        ) {
                            valid = false;
                            break;
                        }
                    }
                    return valid;
                },
            },
        },
        setup(props, { emit }) {
            return
        },
    };
</script>

<style lang="scss" scoped></style>
